<template>
    <div class="app-toolbar" @touchmove.prevent>
        <div class="btn-group">
            <button class="download-btn" @click="downloadApp">
                <img class="icon-logo" src="../assets/toolbar/icon-download.png" />
                Unduh
            </button>

            <button class="add-to-home-btn" @click="showAddToHomeGuide = true">Layar Utama</button>
        </div>

        <template v-if="showAddToHomeGuide">
            <div class="guide-modal" @click.stop="handleClose">
                <div class="step" data-index="1">
                    Klik
                    <img class="icon-step" src="../assets/toolbar/guide_1.png" />
                    Tombol
                </div>

                <div class="step" data-index="2">
                    Klik
                    <img class="icon-step" src="../assets/toolbar/guide_2.png" />
                    Tambah ke Layar Utama
                </div>

                <div class="step" data-index="3">Tambahkan setelah penamaan</div>

                <img class="img-lite" src="../assets/toolbar/guide_3.png" alt="All Sepakbola - Lite">

                <div class="btn-add">Dipahami</div>
            </div>

            <div class="mask" @click.stop="handleClose"></div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showAddToHomeGuide: false,
            downloadLink:'https://app.adjust.com/1e8lce5e_1exw643e'
        }
    },

    methods: {
        downloadApp() {
            window.location.href = this.downloadLink
        },

        handleClose() {
            this.showAddToHomeGuide = false
        }
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: "D-DINExp-Bold";
    src: url("../assets/ttf/D-DINExp-Bold.ttf");
}


* {
    box-sizing: border-box;
}

// 1rem = 16px

.flex(@justify: center) {
    display: flex;
    align-items: center;
    justify-content: @justify;
}

.app-toolbar {
    display: inline-block;
    height: 100%;
    margin: 0 0.375rem 0 auto;
    padding-left: .2rem;
    transform: none;

    .btn-group {
        .flex(flex-start);
        width: max-content;
        height: 100%;

        .download-btn,
        .add-to-home-btn {
            .flex();
            height: 1.1875rem;
            padding: 0 0.1875rem;
            font-size: 0.8rem;
            font-weight: 500;
            border-radius: 0.1875rem;
            border: 1px solid #FFFFFF;
            -webkit-tap-highlight-color: transparent;
            outline: none;
        }

        .download-btn {
            min-width: 3.25rem;
            background: #FFFFFF;

            color: #16B13A;
            font-family: SF UI Display;

            .icon-logo {
                width: 1rem;
                height: 0.625rem;
                margin-right: 0.125rem;
            }
        }

        .add-to-home-btn {
            margin-left: 0.1875rem;
            min-width: 1.8125rem;
            color: #FFFFFF;
            background-color: #16B13A;
        }
    }
}

// 引导弹窗
.guide-modal {
    z-index: 10001;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 11.625rem 2.875rem 1.875rem;

    .step {
        .flex(flex-start);
        position: relative;
        width: 17.6875rem;
        font-weight: 500;
        font-size: 1.0625rem;
        color: #FFFFFF;


        &::before {
            .flex();
            content: attr(data-index);
            margin-right: 0.5625rem;
            width: 1.0625rem;
            height: 1.0625rem;
            font-size: 0.8125rem;
            color: #000000;
            border-radius: 50%;
            background: #FFFFFF;
            font-family: D-DINExp-Bold;
        }

        .icon-step {
            width: 1.125rem;
            height: 1.125rem;
            margin: 0 0.3125rem;
        }
    }

    .img-lite {
        width: 16.125rem;
        height: 3.6875rem;
        margin: 0.6rem 0 2rem 1.5rem
    }

    .btn-add {
        width: 14.3125rem;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        font-size: 0.9375rem;
        font-weight: 500;
        color: #16B13A;
        border-radius: 1.1875rem;
        border: 1px solid #16B13A;
    }
}


.mask {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000000;
    opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// AppToolbar.vue?65f41084